import check from "@/assets/check.svg";
import greyshield from "@/assets/greyshield.svg";
import { Button } from "./ui/button";
import { useFirebaseUser } from "@/hooks/useFirebaseUser";
import { useFirestoreDoc } from "@/hooks/useFirestoreDoc";
import type {
    User,
  } from "@skillscratch/shared-types";
import { useViewTransition } from "@/hooks/useViewTransition";
import { useEffect } from "react";


export function VerifyPaymentMethod() {
    const user = useFirebaseUser();
    const { navigateNormal } = useViewTransition(); 
    
    const handleApplePay = () => {
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        (window.webkit as any)?.messageHandlers?.startApplePay?.postMessage({
            amount: 0,
            storeListingId: 'temp-1',
            priceId: 'temp-1',
            description: "N/A",
            currency: "usd",
            purchaseId: 'verifypayment-placeholder',
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        }, (_: any, error: any) => {
            console.log(error);
        });
      };

    const [userData] = useFirestoreDoc<User>(
        () => {
            const userId = user?.uid;
            if (!userId) {
            return;
            }
            return ["user", userId];
        },
        [user],
        "onSnapshot"
    );

    useEffect(() => {
        if (userData?.customerId) {
            navigateNormal('/index',
                {
                    replace: false,
                    viewTransition: true,
                }
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData])
    
    return (
        <>
            <p className='bg-green mt-6 h-12 flex items-center rounded-sm'>
                <span className='ml-4 text-xl font-semibold text-white'>Phone number verified</span>
            </p>
            <h1 className="text-3xl font-bold text-white mt-10">Verify a method</h1>
            <div className="flex flex-row w-full mt-3">
                <span className='w-6 h-6 flex items-center justify-center lex-shrink-0 rounded-full bg-green-500 mr-2'>
                    <img src={check} alt='checkmark' className='h-3 brightness-0 invert' />
                </span>
                <span className='text-white text-lg font-semibold'>You won't be charged now</span>
            </div>
            <Button className="py-7 bg-blue text-white text-2xl font-bold w-full rounded-lg mt-4 " shine onClick={() => handleApplePay()}>
                Verify payment method
            </Button>
            <div className="flex flex-row w-full mt-4">
                <img src={greyshield} alt='grey-shield' className='h-6 brightness-0 invert opacity-30 mr-2' />
                <span className='text-white text-lg font-semibold opacity-30'>256-bit SSL secure</span>
            </div>
        </>
    )
}
